import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Plus, Download, Eye, Search, Calendar, DollarSign, FileText, Filter, Edit, Save, X } from 'lucide-react';
import { socket } from '../Containers/MainContainer';
import { getNextMonthLastDay } from '../utils';

function ProfessionalInvoiceManager() {
    // State management
    const [invoices, setInvoices] = useState([
        {
            id: 1,
            invoice_id: 'INV2025',
            invoice_nr: '001',
            client_name: 'Acme Corporation',
            client_address: '123 Business St, Suite 100',
            client_country: 'United States',
            tax_id: 'US123456789',
            vat_number: 'VAT123456',
            email_address: 'billing@acme.com',
            issue_date: '15/05/2025',
            due_date: '15/06/2025',
            delivery_date: '15/05/2025',
            items: [{
                name: 'Marketing Services for May 2025',
                quantity: 1,
                price: 2500,
                currency: 'USD',
                exchange: 4.95,
                exchange_to: 'RON',
                exchange_date: '14/05/2025'
            }],
            status: 'paid'
        },
        {
            id: 2,
            invoice_id: 'INV2025',
            invoice_nr: '002',
            client_name: 'Tech Solutions Ltd',
            client_address: '456 Innovation Ave',
            client_country: 'United Kingdom',
            tax_id: 'GB987654321',
            vat_number: 'GB123456789',
            email_address: 'finance@techsolutions.co.uk',
            issue_date: '20/05/2025',
            due_date: '20/06/2025',
            delivery_date: '20/05/2025',
            items: [{
                name: 'Consulting Services for May 2025',
                quantity: 1,
                price: 3200,
                currency: 'USD',
                exchange: 4.95,
                exchange_to: 'RON',
                exchange_date: '19/05/2025'
            }],
            status: 'pending'
        },
        {
            id: 3,
            invoice_id: 'INV2025',
            invoice_nr: '003',
            client_name: 'Global Enterprises Inc',
            client_address: '789 Corporate Blvd',
            client_country: 'Canada',
            tax_id: 'CA456789123',
            vat_number: '',
            email_address: 'accounting@globalent.ca',
            issue_date: '25/05/2025',
            due_date: '25/06/2025',
            delivery_date: '25/05/2025',
            items: [{
                name: 'Development Services for May 2025',
                quantity: 1,
                price: 4800,
                currency: 'USD',
                exchange: 4.95,
                exchange_to: 'RON',
                exchange_date: '24/05/2025'
            }],
            status: 'overdue'
        },
        {
            id: 4,
            invoice_id: 'INV2025',
            invoice_nr: '004',
            client_name: 'StartupXYZ',
            client_address: '321 Startup Lane',
            client_country: 'Germany',
            tax_id: 'DE789123456',
            vat_number: 'DE987654321',
            email_address: 'billing@startupxyz.de',
            issue_date: '30/05/2025',
            due_date: '30/06/2025',
            delivery_date: '30/05/2025',
            items: [{
                name: 'Design Services for May 2025',
                quantity: 1,
                price: 1800,
                currency: 'USD',
                exchange: 4.95,
                exchange_to: 'RON',
                exchange_date: '29/05/2025'
            }],
            status: 'draft'
        },
        {
            id: 5,
            invoice_id: 'INV2025',
            invoice_nr: '005',
            client_name: 'Digital Agency Pro',
            client_address: '654 Creative District',
            client_country: 'Australia',
            tax_id: 'AU123789456',
            vat_number: 'AU456123789',
            email_address: 'finance@digitalagencypro.au',
            issue_date: '02/06/2025',
            due_date: '02/07/2025',
            delivery_date: '02/06/2025',
            items: [{
                name: 'SEO Services for June 2025',
                quantity: 1,
                price: 2200,
                currency: 'USD',
                exchange: 4.95,
                exchange_to: 'RON',
                exchange_date: '01/06/2025'
            }],
            status: 'pending'
        }
    ]);

    const [userProfile, setUserProfile] = useState({})
    const [page, setPage] = useState(1)
    const [pageNumber, setPageNumber] = useState(-1)
    const [userId, setUserId] = useState(0);
    const [canUse, setCanUse] = useState(true);
    const [username, setUsername] = useState('')
    const [rank, setRank] = useState(0)
    const [type, setType] = useState(0)
    const [alert, setAlert] = useState({ show: false, type: '', flagReason: '', code: '', pin: '', id: -1 })
    const [alert2, setAlert2] = useState({ show: false, name: '', reward: 0 })

    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedInvoice, setSelectedInvoice] = useState(0);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editingInvoice, setEditingInvoice] = useState(null);
    const [statusFilter, setStatusFilter] = useState('all');
    const [exchangeRates, setExchangeRates] = useState({});
    const [invoiceClients, setInvoiceClients] = useState([
        {
            id: 1,
            name: 'Acme Corporation',
            address: '123 Business St, Suite 100',
            country: 'United States',
            tax_id: 'US123456789',
            vat_number: 'VAT123456',
            email: 'billing@acme.com'
        },
        {
            id: 2,
            name: 'Tech Solutions Ltd',
            address: '456 Innovation Ave',
            country: 'United Kingdom',
            tax_id: 'GB987654321',
            vat_number: 'GB123456789',
            email: 'finance@techsolutions.co.uk'
        },
        {
            id: 3,
            name: 'Global Enterprises Inc',
            address: '789 Corporate Blvd',
            country: 'Canada',
            tax_id: 'CA456789123',
            vat_number: '',
            email: 'accounting@globalent.ca'
        },
        {
            id: 4,
            name: 'StartupXYZ',
            address: '321 Startup Lane',
            country: 'Germany',
            tax_id: 'DE789123456',
            vat_number: 'DE987654321',
            email: 'billing@startupxyz.de'
        },
        {
            id: 5,
            name: 'Digital Agency Pro',
            address: '654 Creative District',
            country: 'Australia',
            tax_id: 'AU123789456',
            vat_number: 'AU456123789',
            email: 'finance@digitalagencypro.au'
        }
    ]);
    const itemsPerPage = 5;

    // New invoice form state
    const [newInvoice, setNewInvoice] = useState({
        invoice_id: `INV${new Date().getFullYear()}`,
        invoice_nr: '001',
        client_id: '',
        client_name: '',
        client_address: '',
        client_country: '',
        tax_id: '',
        vat_number: '',
        email_address: '',
        issue_date: formatDate(new Date()),
        due_date: getNextMonthDate(),
        delivery_date: formatDate(new Date()),
        items: [{
            id: 1,
            name: `Marketing Services for ${months[new Date().getUTCMonth()]} ${new Date().getFullYear()}`,
            quantity: 1,
            price: 0,
            currency: 'USD',
            exchange: 0,
            exchange_to: 'RON',
            exchange_date: getPreviousBusinessDay()
        }],
        status: 'draft'
    });

    // Utility functions
    function formatDate(date) {
        const day = date.getUTCDate() < 10 ? "0" + date.getUTCDate() : date.getUTCDate();
        const month = (date.getUTCMonth() + 1) < 10 ? "0" + (date.getUTCMonth() + 1) : (date.getUTCMonth() + 1);
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }

    function getNextMonthDate() {
        const nextMonth = new Date();
        nextMonth.setMonth(nextMonth.getMonth() + 1);
        const lastDay = new Date(nextMonth.getFullYear(), nextMonth.getMonth() + 1, 0).getDate();
        return formatDate(new Date(nextMonth.getFullYear(), nextMonth.getMonth(), lastDay));
    }

    function getPreviousBusinessDay() {
        const today = new Date();
        let previousDay = new Date(today);
        previousDay.setDate(today.getDate() - 1);

        // If yesterday was Sunday (0) or Saturday (6), go to Friday
        while (previousDay.getDay() === 0 || previousDay.getDay() === 6) {
            previousDay.setDate(previousDay.getDate() - 1);
        }

        return formatDate(previousDay);
    }
useEffect(() => {
        socket.on('response_get_admin_invoices', (data) => {
            setInvoiceClients(data.invoiceClients)
            setInvoices(data.withdrawals)
            setPageNumber(Math.ceil(data.withdrawalsLength / 5))
            setUserProfile(data)
            setRank(data.rank)
            setSelectedInvoice(data.withdrawals.length-1)
            setAlert2({...alert2,
                invoice_id:`INV${new Date().getFullYear()}`,
                invoice_nr: invoices[0]==undefined?'034':invoices[0].invoice_nr==undefined?'034':invoices[0].invoice_nr.includes('0')?'0'+(parseInt(invoices[0].invoice_nr.split('0')[1])+1):(parseInt(invoices[0].invoice_nr.split('0')[1])+1),
                issue_date: ((new Date().getUTCDate()<10)?"0"+new Date().getUTCDate():new Date().getUTCDate())+'/'+((new Date().getUTCMonth()+1)<10?"0"+(new Date().getUTCMonth()+1):(new Date().getUTCMonth()+1))+'/'+new Date().getFullYear(),
                due_date: (getNextMonthLastDay())+'/'+((new Date().getUTCMonth()+2)<10?"0"+(new Date().getUTCMonth()+2):(new Date().getUTCMonth()+2))+'/'+new Date().getFullYear(),
                delivery_date: ((new Date().getUTCDate()<10)?"0"+new Date().getUTCDate():new Date().getUTCDate())+'/'+((new Date().getUTCMonth()+1)<10?"0"+(new Date().getUTCMonth()+1):(new Date().getUTCMonth()+1))+'/'+new Date().getFullYear(),
                client_name: '',
                client_address: '',
                client_country: '',
                tax_id: '',
                vat_number: '',
                email_address: '',
                item_name:`Marketing Services for ${months[new Date().getUTCMonth()]} ${new Date().getFullYear()}`,
                items_price:0,
                item_quantity:1,
                item_currency:'USD',
                item_exchange:0,
                item_exchange_to:'RON',
                item_exchange_date:(((new Date().getUTCDate()-1)<10)?"0"+(new Date().getUTCDate()-1):(new Date().getUTCDate()-1))+'/'+((new Date().getUTCMonth()+1)<10?"0"+(new Date().getUTCMonth()+1):(new Date().getUTCMonth()+1))+'/'+new Date().getFullYear(),
                item_id:1

            })

        })
        socket.emit('getAdminInvoices', {
            offers_like: username,
            type,
            page:page,
        })

    }, [])
    function generateNextInvoiceNumber() {
        if (invoices.length === 0) return '001';

        const lastInvoice = invoices[0];
        if (!lastInvoice || !lastInvoice.invoice_nr) return '001';

        const lastNumber = parseInt(lastInvoice.invoice_nr);
        const nextNumber = lastNumber + 1;
        return nextNumber.toString().padStart(3, '0');
    }

    // Fetch exchange rates from BNR


    // Handle client selection
    const handleClientSelect = (clientId, invoice, setInvoice) => {
        const selectedClient = invoiceClients.find(client => client.id === parseInt(clientId));
        if (selectedClient) {
            setInvoice({
                ...invoice,
                client_id: clientId,
                client_name: selectedClient.client_name,
                client_address: selectedClient.client_address,
                client_country: selectedClient.client_country,
                tax_id: selectedClient.tax_id,
                vat_number: selectedClient.vat_number,
                email_address: selectedClient.email
            });
        } else {
            // Clear client fields when no client is selected
            setInvoice({
                ...invoice,
                client_id: '',
                client_name: '',
                client_address: '',
                client_country: '',
                tax_id: '',
                vat_number: '',
                email_address: ''
            });
        }
    };

    // Handle items management
    const addItem = (invoice, setInvoice) => {
        const newItemId = Math.max(...invoice.items.map(item => item.id), 0) + 1;
        const newItem = {
            id: newItemId,
            name: `Service ${newItemId}`,
            quantity: 1,
            price: 0,
            currency: 'USD',
            exchange: 0,
            exchange_to: 'RON',
            exchange_date: getPreviousBusinessDay()
        };

        setInvoice({
            ...invoice,
            items: [...invoice.items, newItem]
        });
    };

    const removeItem = (itemId, invoice, setInvoice) => {
        if (invoice.items.length > 1) {
            setInvoice({
                ...invoice,
                items: invoice.items.filter(item => item.id !== itemId)
            });
        }
    };

    const updateItem = (itemId, field, value, invoice, setInvoice) => {
        setInvoice({
            ...invoice,
            items: invoice.items.map(item =>
                item.id === itemId
                    ? { ...item, [field]: value }
                    : item
            )
        });
    };
    useEffect(() => {

        // Update new invoice number
        setNewInvoice(prev => ({
            ...prev,
            invoice_nr: generateNextInvoiceNumber()
        }));
    }, [invoices]);

    // Filtered invoices based on search and status
    const filteredInvoices = invoices.filter(invoice => {
        const matchesSearch = invoice.client_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                            invoice.invoice_id.toLowerCase().includes(searchTerm.toLowerCase()) ||
                            invoice.invoice_nr.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesStatus = statusFilter === 'all' || invoice.status === statusFilter;
        return matchesSearch && matchesStatus;
    });

    // Pagination calculations
    const totalPages = Math.ceil(filteredInvoices.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentInvoices = filteredInvoices.slice(startIndex, endIndex);

    // Reset to first page when search changes
    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm, statusFilter]);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    // Create new invoice
   const handleCreateInvoice = () => {
    const invoice = {
        id: Math.max(...invoices.map(i => i.id), 0) + 1,
        invoice_id: newInvoice.invoice_id,
        invoice_nr: newInvoice.invoice_nr,
        client_name: newInvoice.client_name,
        client_address: newInvoice.client_address,
        client_country: newInvoice.client_country,
        tax_id: newInvoice.tax_id,
        vat_number: newInvoice.vat_number,
        email_address: newInvoice.email_address,
        issue_date: newInvoice.issue_date,
        due_date: newInvoice.due_date,
        delivery_date: newInvoice.delivery_date,
        items: newInvoice.items.map(item => ({
            ...item,
            exchange: exchangeRates[item.currency] || item.exchange
        })),
        status: newInvoice.status
    };

    // Emit socket event for adding invoice
    socket.emit('adminAction', {
        action: "add_invoice",
        page: page,
        show: true,
        name: "",
        reward: 0,
        invoice_id: newInvoice.invoice_id,
        invoice_nr: newInvoice.invoice_nr,
        client_address: newInvoice.client_address,
        client_country: newInvoice.client_country,
        client_id: newInvoice.client_id,
        client_name: newInvoice.client_name,
        delivery_date: newInvoice.delivery_date,
        due_date: newInvoice.due_date,
        email_address: newInvoice.email_address,
        id: invoice.id,
        issue_date: newInvoice.issue_date,
        item_currency: newInvoice.items[0].currency,
        item_exchange: newInvoice.items[0].exchange,
        item_exchange_date: newInvoice.items[0].exchange_date,
        item_exchange_to: newInvoice.items[0].exchange_to,
        item_id: newInvoice.items[0].id,
        item_name: newInvoice.items[0].name,
        item_quantity: newInvoice.items[0].quantity,
        items_price: newInvoice.items[0].price,
        tax_id: newInvoice.tax_id,
        vat_number: newInvoice.vat_number
    });

    setInvoices([invoice, ...invoices]);
    setShowCreateModal(false);

    // Reset form for next invoice
    setNewInvoice({
        ...newInvoice,
        invoice_nr: (parseInt(newInvoice.invoice_nr) + 1).toString().padStart(3, '0'),
        client_id: '',
        client_name: '',
        client_address: '',
        client_country: '',
        tax_id: '',
        vat_number: '',
        email_address: '',
        items: [{
            id: 1,
            name: `Marketing Services for ${months[new Date().getUTCMonth()]} ${new Date().getFullYear()}`,
            quantity: 1,
            price: 0,
            currency: 'USD',
            exchange: 0,
            exchange_to: 'RON',
            exchange_date: getPreviousBusinessDay()
        }]
    });
};

    // Edit invoice
    const handleEditInvoice = (invoice) => {
        setEditingInvoice({
            ...invoice,
            client_id: invoiceClients.find(client => client.name === invoice.client_name)?.id || ''
        });
        setShowEditModal(true);
    };

    const handleSaveEdit = () => {
        const updatedInvoice = {
            ...editingInvoice,
            items: editingInvoice.items.map(item => ({
                ...item,
                exchange: item.exchange
            }))
        };

        setInvoices(invoices.map(inv => inv.id === editingInvoice.id ? updatedInvoice : inv));
        setShowEditModal(false);
        setEditingInvoice(null);
    };

    function generatePDF(name) {
        // We'll use jsPDF for simplicity
        const { jsPDF } = window.jspdf;
        const doc = new jsPDF("portrait", "pt", "a4");
        let width = doc.internal.pageSize.getWidth();
        let height = doc.internal.pageSize.getHeight();

        doc.html(document.querySelector(".invoice-container"), {
          x: 20, // Adjust X and Y offsets for desired positioning
          y: 20,
          html2canvas: {
            scale: 0.85,
          },
          callback: function (pdf) {
            pdf.save(`${name}.pdf`);
          },
        });
    }

    const getStatusColor = (status) => {
        switch (status) {
            case 'paid': return { bg: 'rgba(63,185,80,0.15)', color: '#3fb950' };
            case 'pending': return { bg: 'rgba(210,153,34,0.15)', color: '#d29922' };
            case 'overdue': return { bg: 'rgba(248,81,73,0.15)', color: '#f85149' };
            case 'draft': return { bg: 'rgba(139,148,158,0.15)', color: '#8b949e' };
            default: return { bg: 'rgba(139,148,158,0.15)', color: '#8b949e' };
        }
    };

    const numberWithCommas = (num) => {
        return parseFloat(num).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const totalRevenue = filteredInvoices.reduce((sum, invoice) => {
        return sum + invoice.items.reduce((itemSum, item) => itemSum + (item.quantity * item.price), 0);
    }, 0);

    // Shared input style
    const inputStyle = {
        width: '100%',
        padding: '8px 12px',
        background: '#0d1117',
        border: '1px solid #30363d',
        borderRadius: '8px',
        color: '#e6edf3',
        outline: 'none',
        boxSizing: 'border-box',
        fontSize: '14px'
    };

    const labelStyle = {
        display: 'block',
        fontSize: '14px',
        fontWeight: 500,
        color: '#8b949e',
        marginBottom: '4px'
    };

    return (
        <div style={{ minHeight: '100vh', background: '#0d1117', color: '#e6edf3' }}>
            {/* Header Stats */}
            <div style={{ background: '#161b22', borderBottom: '1px solid #21262d', padding: '24px' }}>
                <div style={{ margin: '0 auto' }}>
                    <h1 style={{ fontSize: '30px', fontWeight: 700, color: '#e6edf3', marginBottom: '24px' }}>Invoice Management</h1>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
                        <div style={{ background: '#161b22', border: '1px solid #21262d', borderLeft: '3px solid #58a6ff', borderRadius: '12px', padding: '16px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div>
                                    <p style={{ color: '#8b949e', fontSize: '13px', margin: '0 0 4px 0' }}>Total Invoices</p>
                                    <p style={{ fontSize: '24px', fontWeight: 700, color: '#e6edf3', margin: 0 }}>{filteredInvoices.length}</p>
                                </div>
                                <FileText style={{ width: '32px', height: '32px', color: '#58a6ff' }} />
                            </div>
                        </div>
                        <div style={{ background: '#161b22', border: '1px solid #21262d', borderLeft: '3px solid #3fb950', borderRadius: '12px', padding: '16px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div>
                                    <p style={{ color: '#8b949e', fontSize: '13px', margin: '0 0 4px 0' }}>Total Revenue</p>
                                    <p style={{ fontSize: '24px', fontWeight: 700, color: '#e6edf3', margin: 0 }}>${numberWithCommas(totalRevenue)}</p>
                                </div>
                                <DollarSign style={{ width: '32px', height: '32px', color: '#3fb950' }} />
                            </div>
                        </div>
                        <div style={{ background: '#161b22', border: '1px solid #21262d', borderLeft: '3px solid #3fb950', borderRadius: '12px', padding: '16px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div>
                                    <p style={{ color: '#8b949e', fontSize: '13px', margin: '0 0 4px 0' }}>Paid Invoices</p>
                                    <p style={{ fontSize: '24px', fontWeight: 700, color: '#e6edf3', margin: 0 }}>{invoices.filter(i => i.status === 'paid').length}</p>
                                </div>
                                <div style={{ width: '12px', height: '12px', background: '#3fb950', borderRadius: '50%' }}></div>
                            </div>
                        </div>
                        <div style={{ background: '#161b22', border: '1px solid #21262d', borderLeft: '3px solid #d29922', borderRadius: '12px', padding: '16px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div>
                                    <p style={{ color: '#8b949e', fontSize: '13px', margin: '0 0 4px 0' }}>Pending</p>
                                    <p style={{ fontSize: '24px', fontWeight: 700, color: '#e6edf3', margin: 0 }}>{invoices.filter(i => i.status === 'pending').length}</p>
                                </div>
                                <div style={{ width: '12px', height: '12px', background: '#d29922', borderRadius: '50%' }}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ margin: '0 auto', padding: '24px' }}>
                <div>
                    {/* Invoice List */}
                    <div>
                        <div style={{ background: '#161b22', borderRadius: '12px', border: '1px solid #21262d' }}>
                            {/* Search and Filters */}
                            <div style={{ padding: '24px', borderBottom: '1px solid #21262d' }}>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div style={{ position: 'relative', flex: 1, maxWidth: '448px' }}>
                                        <Search style={{ position: 'absolute', left: '12px', top: '33%', transform: 'translateY(-50%)', color: '#8b949e', width: '16px', height: '16px' }} />
                                        <input
                                            type="text"
                                            placeholder="Search invoices..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            style={{
                                                ...inputStyle,
                                                paddingLeft: '40px'
                                            }}
                                            onFocus={(e) => e.target.style.borderColor = '#58a6ff'}
                                            onBlur={(e) => e.target.style.borderColor = '#30363d'}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', gap: '12px' }}>
                                        <button
                                            onClick={() => setShowCreateModal(true)}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                padding: '8px 16px',
                                                background: '#238636',
                                                border: '1px solid #2ea043',
                                                borderRadius: '8px',
                                                color: '#ffffff',
                                                fontWeight: 500,
                                                transition: 'all 0.2s',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <Plus style={{ width: '16px', height: '16px' }} />
                                            New Invoice
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Invoice Table */}
                            <div style={{ overflowX: 'auto' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr style={{ background: '#161b22', borderBottom: '1px solid #21262d' }}>
                                            <th style={{ padding: '12px 24px', textAlign: 'left', fontSize: '11px', fontWeight: 500, color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Invoice</th>
                                            <th style={{ padding: '12px 24px', textAlign: 'left', fontSize: '11px', fontWeight: 500, color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Client</th>
                                            <th style={{ padding: '12px 24px', textAlign: 'left', fontSize: '11px', fontWeight: 500, color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Amount</th>
                                            <th style={{ padding: '12px 24px', textAlign: 'left', fontSize: '11px', fontWeight: 500, color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Status</th>
                                            <th style={{ padding: '12px 24px', textAlign: 'left', fontSize: '11px', fontWeight: 500, color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentInvoices.length === 0 ? (
                                            <tr>
                                                <td colSpan="5" style={{ padding: '32px 24px', textAlign: 'center', color: '#484f58' }}>
                                                    No invoices found
                                                </td>
                                            </tr>
                                        ) : (
                                            currentInvoices.map((invoice, index) => {
                                                const statusStyle = getStatusColor(invoice.status);
                                                return (
                                                <tr
                                                    key={invoice.id}
                                                    style={{
                                                        borderBottom: '1px solid #21262d',
                                                        cursor: 'pointer',
                                                        transition: 'background 0.2s',
                                                        background: selectedInvoice === startIndex + index ? 'rgba(88,166,255,0.08)' : 'transparent',
                                                        outline: selectedInvoice === startIndex + index ? '1px solid rgba(88,166,255,0.3)' : 'none'
                                                    }}
                                                    onClick={() => setSelectedInvoice(startIndex + index)}
                                                    onMouseEnter={(e) => { if (selectedInvoice !== startIndex + index) e.currentTarget.style.background = 'rgba(33,38,45,0.5)'; }}
                                                    onMouseLeave={(e) => { if (selectedInvoice !== startIndex + index) e.currentTarget.style.background = 'transparent'; }}
                                                >
                                                    <td style={{ padding: '16px 24px', whiteSpace: 'nowrap' }}>
                                                        <div style={{ fontSize: '14px', fontWeight: 500, color: '#e6edf3' }}>
                                                            {invoice.invoice_id}{invoice.invoice_nr}
                                                        </div>
                                                        <div style={{ fontSize: '14px', color: '#8b949e' }}>{invoice.issue_date}</div>
                                                    </td>
                                                    <td style={{ padding: '16px 24px', whiteSpace: 'nowrap' }}>
                                                        <div style={{ fontSize: '14px', color: '#e6edf3' }}>{invoice.client_name}</div>
                                                        <div style={{ fontSize: '14px', color: '#8b949e' }}>{invoice.client_country}</div>
                                                    </td>
                                                    <td style={{ padding: '16px 24px', whiteSpace: 'nowrap' }}>
                                                        <div style={{ fontSize: '14px', fontWeight: 500, color: '#e6edf3' }}>
                                                            {invoice.items[0].currency} {numberWithCommas(invoice.items[0].price)}
                                                        </div>
                                                    </td>
                                                    <td style={{ padding: '16px 24px', whiteSpace: 'nowrap' }}>
                                                        <span style={{
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            padding: '2px 10px',
                                                            borderRadius: '9999px',
                                                            fontSize: '12px',
                                                            fontWeight: 500,
                                                            textTransform: 'capitalize',
                                                            background: statusStyle.bg,
                                                            color: statusStyle.color
                                                        }}>
                                                            {invoice.status}
                                                        </span>
                                                    </td>
                                                    <td style={{ padding: '16px 24px', whiteSpace: 'nowrap', fontSize: '14px', fontWeight: 500 }}>
                                                        <div style={{ display: 'flex', gap: '8px' }}>
                                                            <button
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setSelectedInvoice(startIndex + index);
                                                                }}
                                                                style={{ background: 'none', border: 'none', color: '#58a6ff', cursor: 'pointer', padding: '4px', transition: 'color 0.2s' }}
                                                                title="View"
                                                            >
                                                                <Eye style={{ width: '16px', height: '16px' }} />
                                                            </button>
                                                            <button
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleEditInvoice(invoice);
                                                                }}
                                                                style={{ background: 'none', border: 'none', color: '#d29922', cursor: 'pointer', padding: '4px', transition: 'color 0.2s' }}
                                                                title="Edit"
                                                            >
                                                                <Edit style={{ width: '16px', height: '16px' }} />
                                                            </button>
                                                            <button
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    generatePDF(`${invoice.invoice_id}${invoice.invoice_nr}`);
                                                                }}
                                                                style={{ background: 'none', border: 'none', color: '#3fb950', cursor: 'pointer', padding: '4px', transition: 'color 0.2s' }}
                                                                title="Download PDF"
                                                            >
                                                                <Download style={{ width: '16px', height: '16px' }} />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Pagination */}
                            <div style={{ padding: '16px 24px', borderTop: '1px solid #21262d' }}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div style={{ fontSize: '14px', color: '#8b949e' }}>
                                        Showing {startIndex + 1} to {Math.min(endIndex, filteredInvoices.length)} of {filteredInvoices.length} results
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <button
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                            style={{
                                                padding: '8px',
                                                borderRadius: '8px',
                                                background: '#161b22',
                                                color: '#c9d1d9',
                                                border: '1px solid #21262d',
                                                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                                opacity: currentPage === 1 ? 0.5 : 1,
                                                transition: 'all 0.2s'
                                            }}
                                        >
                                            <ChevronLeft style={{ width: '16px', height: '16px' }} />
                                        </button>

                                        {[...Array(totalPages)].map((_, index) => {
                                            const pg = index + 1;
                                            return (
                                                <button
                                                    key={pg}
                                                    onClick={() => handlePageChange(pg)}
                                                    style={{
                                                        padding: '8px 12px',
                                                        borderRadius: '8px',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        transition: 'all 0.2s',
                                                        cursor: 'pointer',
                                                        border: currentPage === pg ? '1px solid #2ea043' : '1px solid #21262d',
                                                        background: currentPage === pg ? '#238636' : '#161b22',
                                                        color: currentPage === pg ? '#ffffff' : '#c9d1d9'
                                                    }}
                                                >
                                                    {pg}
                                                </button>
                                            );
                                        })}

                                        <button
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                            style={{
                                                padding: '8px',
                                                borderRadius: '8px',
                                                background: '#161b22',
                                                color: '#c9d1d9',
                                                border: '1px solid #21262d',
                                                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                                opacity: currentPage === totalPages ? 0.5 : 1,
                                                transition: 'all 0.2s'
                                            }}
                                        >
                                            <ChevronRight style={{ width: '16px', height: '16px' }} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Invoice Preview */}
                {invoices[selectedInvoice].items==undefined?'':    <div className="lg:col-span-1" style={{ marginTop: '16px' }}>
                        <div style={{ background: '#161b22', overflowX: 'auto', borderRadius: '12px', border: '1px solid #21262d', padding: '24px', position: 'sticky', top: '24px' }}>
                            <h3 style={{ fontSize: '18px', fontWeight: 600, color: '#e6edf3', marginBottom: '16px' }}>Invoice Preview</h3>
                            {filteredInvoices[selectedInvoice] && (
                                <div className="container-inv" style={{ letterSpacing: "10px" }}>
                                      <div
          className="invoice-container"
          id="frame"
          frameBorder={0}
          sandbox="allow-same-origin"
          style={{ letterSpacing: "0.9px" }}
        >
          <div id="header-inv">
            <div>
              <h1>
                Invoice &nbsp;{invoices[selectedInvoice].invoice_id}
                {invoices[selectedInvoice].invoice_nr}
              </h1>
              <div className="invoice-short-info">
                <dt className="label">Issue date:</dt>
                <dd className="text-black">
                  {invoices[selectedInvoice].issue_date}
                </dd>
                <dt className="label">Due date:</dt>
                <dd className="text-black">
                  {invoices[selectedInvoice].due_date}
                </dd>
                <dt className="label">Delivery date:</dt>
                <dd className="text-black">
                  {invoices[selectedInvoice].delivery_date}
                </dd>
              </div>
            </div>
          </div>
          <table className="bodypart-inv">
            <thead>
              <tr>
                <td>
                  <div id="header-inv-space">&nbsp;</div>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {/* Issuer and recipient info */}
                  <div className="issuer-recipient-block">
                    <div>
                      {/* Issuer info */}
                      <div className="label">Issuer</div>
                      <div className="address-block">
                        <div className="title">
                          LOMORA LAURENTIU PERSOANA FIZICA AUTORIZATA
                        </div>
                        <div>
                          <span>Cal. Chisinaului, Nr. 22H, Bl. C2, Sc. D, Et. 11 Ap. 69</span>
                        </div>
                        <div>
                          <span>700264 </span>
                          Mun. Iasi
                        </div>
                        <div>Iasi</div>
                        <div>Romania</div>
                      </div>
                      <div>
                        <span className="label">Commercee number:</span>{" "}
                        F4/81/2021
                      </div>
                      <div>
                        <span className="label">TAX ID:</span> RO43681925
                      </div>
                      <div>
                        <span className="label">Phone number:</span> 0753461170
                      </div>
                      <div>
                        <span className="label">E-mail:</span>
                        lomoralaurentiu1@gmail.com
                      </div>
                    </div>
                    <div>
                      {/* Recipient info */}
                      <div className="label">Client</div>
                      <div className="address-block">
                        <div className="title">
                          {invoices[selectedInvoice].client_name}
                        </div>
                        <div>
                          <span>
                            {invoices[selectedInvoice].client_address}
                          </span>
                        </div>
                        {/* <div>Lisboa</div> */}
                        <div>
                          {invoices[selectedInvoice].client_country}
                        </div>
                      </div>
                      <div>
                        <span className="label">TAX ID:</span>{" "}
                        {invoices[selectedInvoice].tax_id}
                      </div>
                      {invoices[selectedInvoice].vat_number == "" ? (
                        ""
                      ) : (
                        <div>
                          <span className="label">VAT Number:</span>{" "}
                          {invoices[selectedInvoice].vat_number}
                        </div>
                      )}
                      <div>
                        {invoices[selectedInvoice].email_address ==
                        "" ? (
                          ""
                        ) : (
                          <>
                            <span className="label">E-mail:</span>
                            {invoices[selectedInvoice].email_address}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="payment-info-title">Payment info</div>
                  <div className="payment-info">
                    <div className="payment-info-left">
                      <div className="payment-info-rows">
                        <div>
                          <span className="label">IBAN / Account number:</span>
                          RO90RNCB0029169283620001
                        </div>
                        <div>
                          <span className="label">Bank name:</span> Banca
                          Comerciala Romana
                        </div>
                        <div>
                          <span className="label">SWIFT / BIC code:</span>{" "}
                          RNCBROBUXXX
                        </div>
                        <div>
                          <span className="label">Payment description:</span>
                          {invoices[selectedInvoice].invoice_id}
                          {invoices[selectedInvoice].invoice_nr}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Items */}
                  <table className="header-rounded-corners invoice-items">
                    <thead>
                      <tr className="purple-bg">
                        <th>Item name</th>
                        <th style={{ width: "16%" }}>Quantity</th>
                        <th style={{ width: "16%" }}>Units</th>
                        <th style={{ width: "16%" }}>
                          <span>Unit price</span>,{" "}
                          {invoices[selectedInvoice].items[0].currency}
                        </th>
                        <th style={{ width: "12%" }}>
                          <span>Subtotal</span>,{" "}
                          {invoices[selectedInvoice].items[0].currency}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {invoices[selectedInvoice].items.map((item) => {
                        return (
                          <tr className='invoice-item'>
                            <td>
                              <div>{item.name}</div>
                            </td>
                            <td>{item.quantity}</td>
                            <td />
                            <td>{numberWithCommas(item.price)}</td>
                            <td>
                              {numberWithCommas(item.quantity * item.price)}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  {/*Summary and additional info*/}
                  <div className="summary-additional-info">
                    {/*Additional info*/}
                    <div />
                    {/*Summary*/}
                    <div>
                      <div className="summary-table">
                        <div className="total-amount-item">
                          <div className="total-amount">Total:</div>
                          <div className="total-amount">
                            {
                              invoices[selectedInvoice].items[0]
                                .currency
                            }
                            &nbsp;
                            {numberWithCommas(
                              invoices[selectedInvoice].items
                                .map((item) => item.quantity * item.price)
                                .reduce((a, b) => a + b, 0)
                                .toFixed(2)
                            )}
                          </div>
                        </div>
                        <div className="exchange-rate-item">
                          <div>
                            1{" "}
                            {
                              invoices[selectedInvoice].items[0]
                                .currency
                            }{" "}
                            ={" "}
                            {
                              invoices[selectedInvoice].items[0]
                                .exchange_to
                            }
                            &nbsp;
                            {
                              invoices[selectedInvoice].items[0]
                                .exchange
                            }
                          </div>
                          <div>
                            {
                              invoices[selectedInvoice].items[0]
                                .exchange_to
                            }
                            &nbsp;
                            {numberWithCommas(
                              parseFloat(
                                invoices[selectedInvoice].items
                                  .map((item) => item.quantity * item.price)
                                  .reduce((a, b) => a + b, 0)
                                  .toFixed(2) *
                                  invoices[selectedInvoice].items[0]
                                    .exchange
                              ).toFixed(2)
                            )}
                          </div>
                        </div>
                        <div className="exchange-rate-item">
                          <div>Exchange date:</div>
                          <div>
                            {
                              invoices[selectedInvoice].items[0]
                                .exchange_date
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>
                  <div id="footer-inv-space">&nbsp;</div>
                </td>
              </tr>
            </tfoot>
          </table>
          <div id="footer-inv">
            <div className="footer-left">
              <div>
                The invoice is valid without signature and stamp, according to
                art. 319 paragraph (29) of Law no. 227/2015 regarding the Fiscal
                Code.
              </div>
              <div>
                VAT exempted, as per art. 310 of Law 227/2015 regarding the
                Fiscal Code.
              </div>
            </div>
          </div>
        </div>

                                    <button
                                        onClick={() => generatePDF(`${filteredInvoices[selectedInvoice].invoice_id}${filteredInvoices[selectedInvoice].invoice_nr}`)}
                                        style={{
                                            width: '100%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '8px',
                                            padding: '8px 16px',
                                            background: '#238636',
                                            border: '1px solid #2ea043',
                                            borderRadius: '8px',
                                            color: '#ffffff',
                                            fontWeight: 500,
                                            transition: 'all 0.2s',
                                            cursor: 'pointer',
                                            marginTop: '12px'
                                        }}
                                    >
                                        <Download style={{ width: '16px', height: '16px' }} />
                                        Download PDF
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>}
            </div>

            {/* Create Invoice Modal */}

            {showCreateModal && (
               <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: '16px' }}>
            <div style={{ background: '#161b22', borderRadius: '12px', maxWidth: '896px', width: '100%', maxHeight: '90vh', overflowY: 'auto', border: '1px solid #30363d' }}>
                <div style={{ padding: '24px', borderBottom: '1px solid #21262d' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <h2 style={{ fontSize: '20px', fontWeight: 600, color: '#e6edf3', margin: 0 }}>Create invoice</h2>
                        <button
                            type="button"
                            onClick={(e)=>{setShowCreateModal(false)}}
                            style={{ background: 'none', border: 'none', color: '#8b949e', cursor: 'pointer', padding: '4px', transition: 'color 0.2s' }}
                        >
                            <X style={{ width: '20px', height: '20px' }} />
                        </button>
                    </div>
                </div>

                <div onSubmit={(e) => e.preventDefault()}>
                    <div style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '24px' }}>
                        {/* Invoice Info */}
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                            <div>
                                <label style={labelStyle}>Invoice ID</label>
                                <input
                                    type="text"
                                    value={newInvoice.invoice_id}
                                    onChange={(e) => setNewInvoice({ ...newInvoice, invoice_id: e.target.value })}
                                    style={inputStyle}
                                    onFocus={(e) => e.target.style.borderColor = '#58a6ff'}
                                    onBlur={(e) => e.target.style.borderColor = '#30363d'}
                                />
                            </div>
                            <div>
                                <label style={labelStyle}>Invoice Number</label>
                                <input
                                    type="text"
                                    value={newInvoice.invoice_nr}
                                    onChange={(e) => setNewInvoice({ ...newInvoice, invoice_nr: e.target.value })}
                                    style={inputStyle}
                                    onFocus={(e) => e.target.style.borderColor = '#58a6ff'}
                                    onBlur={(e) => e.target.style.borderColor = '#30363d'}
                                />
                            </div>
                        </div>

                        {/* Client Selection */}
                        <div style={{ background: '#0d1117', borderRadius: '12px', padding: '16px', border: '1px solid #21262d' }}>
                            <h3 style={{ fontSize: '18px', fontWeight: 500, color: '#e6edf3', marginBottom: '16px' }}>Client Information</h3>

                            <div style={{ marginBottom: '16px' }}>
                                <label style={labelStyle}>Select Existing Client</label>
                                <select
                                    value={newInvoice.client_id || ''}
                                    onChange={(e) => handleClientSelect(e.target.value, newInvoice, setNewInvoice)}
                                    style={inputStyle}
                                >
                                    <option value="">Select a client or enter manually</option>
                                    {invoiceClients.map(client => (
                                        <option key={client.id} value={client.id}>
                                            {client.client_name} - {client.client_country}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div>
                                    <label style={labelStyle}>Client Name</label>
                                    <input
                                        type="text"
                                        value={newInvoice.client_name}
                                        onChange={(e) => setNewInvoice({ ...newInvoice, client_name: e.target.value })}
                                        style={inputStyle}
                                        onFocus={(e) => e.target.style.borderColor = '#58a6ff'}
                                        onBlur={(e) => e.target.style.borderColor = '#30363d'}
                                    />
                                </div>
                                <div>
                                    <label style={labelStyle}>Client Address</label>
                                    <input
                                        type="text"
                                        value={newInvoice.client_address}
                                        onChange={(e) => setNewInvoice({ ...newInvoice, client_address: e.target.value })}
                                        style={inputStyle}
                                        onFocus={(e) => e.target.style.borderColor = '#58a6ff'}
                                        onBlur={(e) => e.target.style.borderColor = '#30363d'}
                                    />
                                </div>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', marginTop: '16px' }}>
                                <div>
                                    <label style={labelStyle}>Country</label>
                                    <input
                                        type="text"
                                        value={newInvoice.client_country}
                                        onChange={(e) => setNewInvoice({ ...newInvoice, client_country: e.target.value })}
                                        style={inputStyle}
                                        onFocus={(e) => e.target.style.borderColor = '#58a6ff'}
                                        onBlur={(e) => e.target.style.borderColor = '#30363d'}
                                    />
                                </div>
                                <div>
                                    <label style={labelStyle}>Tax ID</label>
                                    <input
                                        type="text"
                                        value={newInvoice.tax_id}
                                        onChange={(e) => setNewInvoice({ ...newInvoice, tax_id: e.target.value })}
                                        style={inputStyle}
                                        onFocus={(e) => e.target.style.borderColor = '#58a6ff'}
                                        onBlur={(e) => e.target.style.borderColor = '#30363d'}
                                    />
                                </div>
                                <div>
                                    <label style={labelStyle}>VAT Number</label>
                                    <input
                                        type="text"
                                        value={newInvoice.vat_number}
                                        onChange={(e) => setNewInvoice({ ...newInvoice, vat_number: e.target.value })}
                                        style={inputStyle}
                                        onFocus={(e) => e.target.style.borderColor = '#58a6ff'}
                                        onBlur={(e) => e.target.style.borderColor = '#30363d'}
                                    />
                                </div>
                            </div>

                            <div style={{ marginTop: '16px' }}>
                                <label style={labelStyle}>Email</label>
                                <input
                                    type="email"
                                    value={newInvoice.email_address}
                                    onChange={(e) => setNewInvoice({ ...newInvoice, email_address: e.target.value })}
                                    style={inputStyle}
                                    onFocus={(e) => e.target.style.borderColor = '#58a6ff'}
                                    onBlur={(e) => e.target.style.borderColor = '#30363d'}
                                />
                            </div>
                        </div>

                        {/* Dates */}
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px' }}>
                            <div>
                                <label style={labelStyle}>Issue Date</label>
                                <input
                                    type="text"
                                    value={newInvoice.issue_date}
                                    onChange={(e) => setNewInvoice({ ...newInvoice, issue_date: e.target.value })}
                                    style={inputStyle}
                                    onFocus={(e) => e.target.style.borderColor = '#58a6ff'}
                                    onBlur={(e) => e.target.style.borderColor = '#30363d'}
                                />
                            </div>
                            <div>
                                <label style={labelStyle}>Due Date</label>
                                <input
                                    type="text"
                                    value={newInvoice.due_date}
                                    onChange={(e) => setNewInvoice({ ...newInvoice, due_date: e.target.value })}
                                    style={inputStyle}
                                    onFocus={(e) => e.target.style.borderColor = '#58a6ff'}
                                    onBlur={(e) => e.target.style.borderColor = '#30363d'}
                                />
                            </div>
                            <div>
                                <label style={labelStyle}>Delivery Date</label>
                                <input
                                    type="text"
                                    value={newInvoice.delivery_date}
                                    onChange={(e) => setNewInvoice({ ...newInvoice, delivery_date: e.target.value })}
                                    style={inputStyle}
                                    onFocus={(e) => e.target.style.borderColor = '#58a6ff'}
                                    onBlur={(e) => e.target.style.borderColor = '#30363d'}
                                />
                            </div>
                        </div>

                        {/* Items Section */}
                        <div style={{ background: '#0d1117', borderRadius: '12px', padding: '16px', border: '1px solid #21262d' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
                                <h3 style={{ fontSize: '18px', fontWeight: 500, color: '#e6edf3', margin: 0 }}>Invoice Items</h3>
                                <button
                                    type="button"
                                    onClick={() => addItem(newInvoice, setNewInvoice)}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        padding: '4px 12px',
                                        background: 'rgba(88,166,255,0.15)',
                                        border: '1px solid #58a6ff',
                                        borderRadius: '6px',
                                        color: '#58a6ff',
                                        fontSize: '14px',
                                        transition: 'all 0.2s',
                                        cursor: 'pointer'
                                    }}
                                >
                                    <Plus style={{ width: '16px', height: '16px' }} />
                                    Add Item
                                </button>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                {newInvoice.items && newInvoice.items.map((item, index) => (
                                    <div key={item.id || index} style={{ background: '#161b22', borderRadius: '8px', padding: '16px', border: '1px solid #21262d' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                                            <h4 style={{ color: '#e6edf3', fontWeight: 500, margin: 0 }}>Item {index + 1}</h4>
                                            {newInvoice.items.length > 1 && (
                                                <button
                                                    type="button"
                                                    onClick={() => removeItem(item.id || index, newInvoice, setNewInvoice)}
                                                    style={{ background: 'none', border: 'none', color: '#f85149', cursor: 'pointer', padding: '4px', transition: 'color 0.2s' }}
                                                >
                                                    <X style={{ width: '16px', height: '16px' }} />
                                                </button>
                                            )}
                                        </div>

                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                            <div>
                                                <label style={labelStyle}>Item Name</label>
                                                <input
                                                    type="text"
                                                    value={item.name || ''}
                                                    onChange={(e) => updateItem(item.id || index, 'name', e.target.value, newInvoice, setNewInvoice)}
                                                    style={inputStyle}
                                                    onFocus={(e) => e.target.style.borderColor = '#58a6ff'}
                                                    onBlur={(e) => e.target.style.borderColor = '#30363d'}
                                                />
                                            </div>

                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '12px' }}>
                                                <div>
                                                    <label style={labelStyle}>Quantity</label>
                                                    <input
                                                        type="number"
                                                        value={item.quantity || 1}
                                                        onChange={(e) => updateItem(item.id || index, 'quantity', parseInt(e.target.value) || 1, newInvoice, setNewInvoice)}
                                                        style={inputStyle}
                                                        min="1"
                                                        onFocus={(e) => e.target.style.borderColor = '#58a6ff'}
                                                        onBlur={(e) => e.target.style.borderColor = '#30363d'}
                                                    />
                                                </div>
                                                <div>
                                                    <label style={labelStyle}>Price</label>
                                                    <input
                                                        type="number"
                                                        value={item.price || 0}
                                                        onChange={(e) => updateItem(item.id || index, 'price', parseFloat(e.target.value) || 0, newInvoice, setNewInvoice)}
                                                        style={inputStyle}
                                                        min="0"
                                                        step="0.01"
                                                        onFocus={(e) => e.target.style.borderColor = '#58a6ff'}
                                                        onBlur={(e) => e.target.style.borderColor = '#30363d'}
                                                    />
                                                </div>
                                                <div>
                                                    <label style={labelStyle}>Currency</label>
                                                    <select
                                                        value={item.currency || 'USD'}
                                                        onChange={(e) => updateItem(item.id || index, 'currency', e.target.value, newInvoice, setNewInvoice)}
                                                        style={inputStyle}
                                                    >
                                                        <option value="USD">USD</option>
                                                        <option value="EUR">EUR</option>
                                                        <option value="GBP">GBP</option>
                                                        <option value="RON">RON</option>
                                                    </select>
                                                </div>
                                                <div>
                                                    <label style={labelStyle}>Exchange</label>
                                                    <input
                                                        type="number"
                                                        value={item.exchange || 1}
                                                        onChange={(e) => updateItem(item.id || index, 'exchange', parseFloat(e.target.value) || 1, newInvoice, setNewInvoice)}
                                                        style={inputStyle}
                                                        min="0"
                                                        step="0.01"
                                                        onFocus={(e) => e.target.style.borderColor = '#58a6ff'}
                                                        onBlur={(e) => e.target.style.borderColor = '#30363d'}
                                                    />
                                                </div>
                                            </div>

                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px' }}>
                                                <span style={{ color: '#8b949e' }}>
                                                    Exchange Rate: 1 {item.currency} = {item.exchange || exchangeRates[item.currency] || 'N/A'} RON
                                                </span>
                                                <span style={{ color: '#e6edf3', fontWeight: 500 }}>
                                                    Subtotal: {item.currency} {numberWithCommas((item.quantity || 1) * (item.price || 0))}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Total */}
                            <div style={{ marginTop: '16px', paddingTop: '16px', borderTop: '1px solid #21262d' }}>
                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <div style={{ textAlign: 'right' }}>
                                        <div style={{ fontSize: '18px', fontWeight: 600, color: '#e6edf3' }}>
                                            Total: {newInvoice.items && newInvoice.items.length > 0 ? newInvoice.items[0].currency : 'USD'} {
                                                newInvoice.items ? numberWithCommas(
                                                    newInvoice.items.reduce((sum, item) => sum + ((item.quantity || 1) * (item.price || 0)), 0)
                                                ) : '0.00'
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Status */}
                        <div>
                            <label style={labelStyle}>Status</label>
                            <select
                                value={newInvoice.status}
                                onChange={(e) => setNewInvoice({ ...newInvoice, status: e.target.value })}
                                style={inputStyle}
                            >
                                <option value="draft">Draft</option>
                                <option value="pending">Pending</option>
                                <option value="paid">Paid</option>
                                <option value="overdue">Overdue</option>
                            </select>
                        </div>
                    </div>

                    <div style={{ padding: '24px', borderTop: '1px solid #21262d', display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                        <button
                            type="button"
                            onClick={(e)=>{setShowCreateModal(false)}}
                            style={{
                                padding: '8px 16px',
                                background: '#21262d',
                                border: '1px solid #30363d',
                                borderRadius: '8px',
                                color: '#c9d1d9',
                                transition: 'all 0.2s',
                                cursor: 'pointer'
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            onClick={handleCreateInvoice}
                            style={{
                                padding: '8px 16px',
                                background: '#238636',
                                border: '1px solid #2ea043',
                                borderRadius: '8px',
                                color: '#ffffff',
                                transition: 'all 0.2s',
                                cursor: 'pointer',
                                fontWeight: 500
                            }}
                        >
                            {false==true ? 'Save Changes' : 'Create Invoice'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
            )}

            {/* Edit Invoice Modal */}
            {/* <InvoiceModal
                show={showEditModal}
                onClose={() => {
                    setShowEditModal(false);
                    setEditingInvoice(null);
                }}
                title="Edit Invoice"
                invoice={editingInvoice || {}}
                onChange={setEditingInvoice}
                onSave={handleSaveEdit}
                isEdit={true}
            /> */}
        </div>
    );
}

export default ProfessionalInvoiceManager;
